const origin =
  window.origin === 'http://localhost:4000'
    ? 'https://dev.callloop.com'
    : window.origin

export const conversionCodeScript = `<script async type="text/javascript" src='${origin}/conversion.js'></script>`
